import { render } from "./Contributors.vue?vue&type=template&id=0b366db1&scoped=true"
import script from "./Contributors.vue?vue&type=script&lang=js"
export * from "./Contributors.vue?vue&type=script&lang=js"

import "./Contributors.vue?vue&type=style&index=0&id=0b366db1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b366db1"]])

export default __exports__